var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('Slide',{attrs:{"value":_vm.bannerSetting,"hidden-indicator":_vm.hiddenIndicator,"hide-video-controls":_vm.hideVideoControls,"loop-single-video":_vm.loopSingleVideo,"slide-arrow":_vm.slideArrow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }